import api from './api'
import type { User } from '@/types'

function mapAuthUser(raw: Record<string, unknown>): User {
  const avatarUrl = (raw.avatarUrl ?? raw.avatar ?? null) as string | null
  return {
    id: String(raw.id),
    name: String(raw.name ?? ''),
    email: String(raw.email ?? ''),
    role: String(raw.role ?? 'bdr').toLowerCase() as User['role'],
    setor: (raw.setor as string | null | undefined) ?? null,
    avatarUrl: avatarUrl || undefined,
    active: Boolean(raw.active ?? raw.isActive ?? true),
    canViewContractFinance: Boolean(raw.canViewContractFinance),
    eventModeActive: Boolean(raw.eventModeActive),
    eventModeActivatedAt: (raw.eventModeActivatedAt as string | null | undefined) ?? null,
    createdAt: String(raw.createdAt ?? new Date().toISOString()),
  }
}

export const authService = {
  async logout() {
    await api.post('/auth/logout', {}, { withCredentials: true })
  },

  async uploadAvatar(file: File) {
    const formData = new FormData()
    formData.append('avatar', file)
    const response = await api.post<{ success: boolean; data: { user: Record<string, unknown> } }>(
      '/auth/me/avatar',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    return mapAuthUser(response.data.data.user)
  },

  async updateName(name: string) {
    const response = await api.patch<{ success: boolean; data: { user: Record<string, unknown> } }>(
      '/auth/me',
      { name },
    )
    return mapAuthUser(response.data.data.user)
  },

  async changePassword(input: { currentPassword: string; newPassword: string }) {
    await api.post('/auth/me/password', input)
  },

  async removeAvatar() {
    const response = await api.delete<{ success: boolean; data: { user: Record<string, unknown> } }>(
      '/auth/me/avatar',
    )
    return mapAuthUser(response.data.data.user)
  },
}
